import { toTypedSchema } from '@vee-validate/zod'
import * as zod from 'zod'

export const commentValidationSchema = toTypedSchema(
    zod.object({
        commentId: zod.number().optional(),
        text: zod.string().trim().min(1, 'formInputs.validation.requiredText'),
        file: zod.union([zod.instanceof(File), zod.object({
            id: zod.number(),
            name: zod.string(),
            size: zod.string(),
        })]).optional(),
    }),
)
